import { FC, memo, useMemo } from "react";
import LoyaltyCardRank, {
  LoyaltyCardRankProps,
} from "components/molecules/LoyaltyCardRank";
import { useLocation, useNavigate } from "react-router-dom";
import { GET_POPUP_TYPES } from "constants/popupConfig";
import { RankBFF } from "types/LoyaltyBFF";
import { useGetUserProgressLoyalty } from "queries/useGetUserProgressLoyalty";
import { getChestLoyalty } from "utils/loyalty";
import url from "../../url";

type LoyaltyCardRankContainerProps = LoyaltyCardRankProps;

const LoyaltyCardRankContainerComponent: FC<LoyaltyCardRankContainerProps> = (
  props,
) => {
  const { nameRank, level = undefined } = props;
  const location = useLocation();
  const navigate = useNavigate();
  const { data: bffLoyalty, isLoading } = useGetUserProgressLoyalty();
  const indexRank = bffLoyalty?.ranks.findIndex((r) => r.name === nameRank);
  const rank = bffLoyalty?.ranks?.[indexRank as number] as RankBFF;
  const levelRank = rank?.levels.find((l) => l.name === Number(level));
  const allRewardsIsGetting = levelRank?.rewards
    ? Object.values(levelRank?.rewards)?.every(
        (item) => item?.loyaltyRewardInfo?.status === "assigned",
      )
    : false;
  const experience = props?.userExperience || 0;
  const image = useMemo(
    () =>
      getChestLoyalty(indexRank, levelRank, allRewardsIsGetting, experience),
    [indexRank, levelRank, allRewardsIsGetting, experience],
  );

  const onHandleClickButtonCard = () => {
    if (level) {
      if (props?.userExperience >= props?.rankExperience) {
        navigate(
          `${location.pathname}?popup=${GET_POPUP_TYPES.popup.rewardsLevelCompleted}&name=${nameRank}&level=${level}&isComplete=1`,
          { replace: true },
        );
      } else {
        navigate(
          `${location.pathname}?popup=${GET_POPUP_TYPES.popup.rewardsLevel}&name=${nameRank}&level=${level}&isComplete=2`,
          { replace: true },
        );
      }
      return;
    }
    navigate(url.routes.profile.loyaltyProgramRanks());
  };

  return (
    <LoyaltyCardRank
      {...props}
      image={image}
      isLoading={isLoading}
      handleClick={onHandleClickButtonCard}
      allRewardsIsGetting={allRewardsIsGetting}
    />
  );
};

export const LoyaltyCardRankContainer = memo(LoyaltyCardRankContainerComponent);
